<template>
  <div class="lbv-device-list tenant-list animated fadeIn roundedCard">
    <div class="row">
      <div class="col-lg-12">
        <b-card>
          <h1 class="lbv-page-title tenantPage">
            Tenant List
            <b-btn
              v-model="addTenant"
              v-b-modal.modalAddTenant
              class="addTenantBtn"
              variant="primary"
              @click="showModal = true"
            >
              Add New Tenant
            </b-btn>
          </h1>
          <b-table
            responsive
            striped
            hover
            :items="tenantsList"
            :fields="fields"
          >
            <template
              slot="name"
              slot-scope="data"
            >
              <b-link
                class="tenantLink"
                @click="editTenant(data)"
              >
                {{ data.value }}
              </b-link>
            </template>
          </b-table>

          <b-modal
            id="modalAddTenant"
            title="Add Tenant"
            ok-variant="primary"
            ok-title="Add Tenant"
            cancel-title="Cancel"
            @ok="addTenant"
          >
            <div class="col-md-12">
              <b-form-group>
                <p><strong>Name</strong></p>
                <b-form-input
                  v-model="tenantName"
                  class="col-md-10"
                  type="text"
                />
              </b-form-group>

              <b-form-group>
                <p><strong>Tenant Code</strong></p>
                <b-form-input
                  v-model="tenantCode"
                  class="col-md-10"
                  type="text"
                />
              </b-form-group>

              <b-form-group>
                <p><strong>Leak Days Threshold</strong></p>
                <b-form-input
                  v-model="leakDaysThreshold"
                  class="col-md-10"
                  type="text"
                />
              </b-form-group>

              <b-form-group>
                <p><strong>Leak Reminder Frequency</strong></p>
                <b-form-input
                  v-model="leakReminderFrequency"
                  class="col-md-10"
                  type="text"
                />
              </b-form-group>

              <b-form-group>
                <p><strong>Max Number Of Leak Alert Reminders</strong></p>
                <b-form-input
                  v-model="maxNumberOfLeakAlertReminders"
                  class="col-md-10"
                  type="text"
                />
              </b-form-group>

              <b-form-group>
                <p><strong>Monthly Updates Frequency</strong></p>
                <b-form-input
                  v-model="monthlyUpdatesFrequency"
                  class="col-md-10"
                  type="text"
                />
              </b-form-group>

              <b-form-group>
                <p><strong>Install Chasers Frequency</strong></p>
                <b-form-input
                  v-model="installChasersFrequency"
                  class="col-md-10"
                  type="text"
                />
              </b-form-group>

              <b-form-group>
                <p><strong>Max Number of Install Chasers</strong></p>
                <b-form-input
                  v-model="maxNumberOfInstallChasers"
                  class="col-md-10"
                  type="text"
                />
              </b-form-group>

              <b-form-group>
                <p><strong>Lost Connection Frequency</strong></p>
                <b-form-input
                  v-model="lostConnectionFrequency"
                  class="col-md-10"
                  type="text"
                />
              </b-form-group>

              <b-form-group>
                <p><strong>Max Number of Lost Connection Reminders</strong></p>
                <b-form-input
                  v-model="maxNumberofLostConnectionReminders"
                  class="col-md-10"
                  type="text"
                />
              </b-form-group>

              <b-form-group>
                <p><strong>Frozen Pipe Threshold</strong></p>
                <b-form-input
                  v-model="frozenPipeThreshold"
                  class="col-md-10"
                  type="text"
                />
              </b-form-group>

              <div class="col-md-6 left">
                <b-form-checkbox
                  v-model="surveyAllowed"
                  :plain="true"
                  value="1"
                  unchecked-value="0"
                >
                  Survey Allowed
                </b-form-checkbox>
                <b-form-checkbox
                  v-model="waterUsageAllowed"
                  :plain="true"
                  value="1"
                  unchecked-value="0"
                >
                  Water Usage Allowed
                </b-form-checkbox>
                <b-form-checkbox
                  v-model="leakDaysAllowed"
                  :plain="true"
                  value="1"
                  unchecked-value="0"
                >
                  Leak Days Allowed
                </b-form-checkbox>
                <b-form-checkbox
                  v-model="monthlyUpdatesAllowed"
                  :plain="true"
                  value="1"
                  unchecked-value="0"
                >
                  Monthly Updates Allowed
                </b-form-checkbox>
                <b-form-checkbox
                  v-model="vacantPropertyLeakTest"
                  :plain="true"
                  value="1"
                  unchecked-value="0"
                >
                  Vacant Property Leak Test
                </b-form-checkbox>
              </div>

              <div class="col-md-6 left">
                <b-form-checkbox
                  v-model="smsAllowed"
                  :plain="true"
                  value="1"
                  unchecked-value="0"
                >
                  Send Texts
                </b-form-checkbox>

                <b-form-checkbox
                  v-model="emailAllowed"
                  :plain="true"
                  value="1"
                  unchecked-value="0"
                >
                  Send Emails
                </b-form-checkbox>

                <b-form-checkbox
                  v-model="highflowSmsAllowed"
                  :plain="true"
                  value="1"
                  unchecked-value="0"
                >
                  Highflow SMS Allowed
                </b-form-checkbox>
              </div>

              <div class="col-md-6 left">
                <b-form-checkbox
                  v-model="frozenPipe"
                  :plain="true"
                  value="1"
                  unchecked-value="0"
                >
                  Frozen Pipe
                </b-form-checkbox>
              </div>

              <div class="clear" />
              <b-form-group>
                <p><strong>Leak Repaired Survey</strong></p>
                <b-form-input
                  v-model="leakRepairedSurvey"
                  class="col-md-10"
                  type="text"
                />
              </b-form-group>

              <b-form-group>
                <p><strong>Leak Active No Diagnose Survey</strong></p>
                <b-form-input
                  v-model="leakActiveNoDiagnoseSurvey"
                  class="col-md-10"
                  type="text"
                />
              </b-form-group>

              <b-form-group>
                <p><strong>Install Success Survey</strong></p>
                <b-form-input
                  v-model="installSuccessSurvey"
                  class="col-md-10"
                  type="text"
                />
              </b-form-group>

              <b-form-group>
                <p><strong>Leak Active Survey</strong></p>
                <b-form-input
                  v-model="leakActiveSurvey"
                  class="col-md-10"
                  type="text"
                />
              </b-form-group>
            </div>
          </b-modal>

          <b-modal
            id="modalEditTenant"
            ref="editTenant"
            title="Update Tenant"
            ok-variant="primary"
            ok-title="Update Tenant"
            cancel-title="Cancel"
            @ok="updateTenant"
          >
            <div class="col-md-12">
              <b-form-group>
                <p><strong>Name</strong></p>
                <b-form-input
                  v-model="oldTenantName"
                  class="col-md-10"
                  type="text"
                />
              </b-form-group>

              <b-form-group>
                <p><strong>Tenant Code</strong></p>
                <b-form-input
                  v-model="oldTenantCode"
                  class="col-md-10"
                  type="text"
                />
              </b-form-group>

              <b-form-group>
                <p><strong>Leak Days Threshold</strong></p>
                <b-form-input
                  v-model="oldLeakDaysThreshold"
                  class="col-md-10"
                  type="text"
                />
              </b-form-group>

              <b-form-group>
                <p><strong>Leak Reminder Frequency</strong></p>
                <b-form-input
                  v-model="oldLeakReminderFrequency"
                  class="col-md-10"
                  type="text"
                />
              </b-form-group>

              <b-form-group>
                <p><strong>Max Number Of Leak Alert Reminders</strong></p>
                <b-form-input
                  v-model="oldMaxNumberOfLeakAlertReminders"
                  class="col-md-10"
                  type="text"
                />
              </b-form-group>

              <b-form-group>
                <p><strong>Monthly Updates Frequency</strong></p>
                <b-form-input
                  v-model="oldMonthlyUpdatesFrequency"
                  class="col-md-10"
                  type="text"
                />
              </b-form-group>

              <b-form-group>
                <p><strong>Install Chasers Frequency</strong></p>
                <b-form-input
                  v-model="oldInstallChasersFrequency"
                  class="col-md-10"
                  type="text"
                />
              </b-form-group>

              <b-form-group>
                <p><strong>Max Number of Install Chasers</strong></p>
                <b-form-input
                  v-model="oldMaxNumberOfInstallChasers"
                  class="col-md-10"
                  type="text"
                />
              </b-form-group>

              <b-form-group>
                <p><strong>Lost Connection Frequency</strong></p>
                <b-form-input
                  v-model="oldLostConnectionFrequency"
                  class="col-md-10"
                  type="text"
                />
              </b-form-group>

              <b-form-group>
                <p><strong>Max Number of Lost Connection Reminders</strong></p>
                <b-form-input
                  v-model="oldMaxNumberofLostConnectionReminders"
                  class="col-md-10"
                  type="text"
                />
              </b-form-group>

              <b-form-group>
                <p><strong>Frozen Pipe Threshold</strong></p>
                <b-form-input
                  v-model="oldFrozenPipeThreshold"
                  class="col-md-10"
                  type="text"
                />
              </b-form-group>

              <div class="col-md-6 left">
                <b-form-checkbox
                  v-model="oldSurveyAllowed"
                  :plain="true"
                  value="1"
                  unchecked-value="0"
                >
                  Survey Allowed
                </b-form-checkbox>
                <b-form-checkbox
                  v-model="oldWaterUsageAllowed"
                  :plain="true"
                  value="1"
                  unchecked-value="0"
                >
                  Water Usage Allowed
                </b-form-checkbox>
                <b-form-checkbox
                  v-model="oldLeakDaysAllowed"
                  :plain="true"
                  value="1"
                  unchecked-value="0"
                >
                  Leak Days Allowed
                </b-form-checkbox>
                <b-form-checkbox
                  v-model="oldMonthlyUpdatesAllowed"
                  :plain="true"
                  value="1"
                  unchecked-value="0"
                >
                  Monthly Updates Allowed
                </b-form-checkbox>
                <b-form-checkbox
                  v-model="oldVacantPropertyLeakTest"
                  :plain="true"
                  value="1"
                  unchecked-value="0"
                >
                  Vacant Property Leak Test
                </b-form-checkbox>
              </div>

              <div class="col-md-6 left">
                <b-form-checkbox
                  v-model="oldSmsAllowed"
                  :plain="true"
                  value="1"
                  unchecked-value="0"
                >
                  Send Texts
                </b-form-checkbox>

                <b-form-checkbox
                  v-model="oldEmailAllowed"
                  :plain="true"
                  value="1"
                  unchecked-value="0"
                >
                  Send Emails
                </b-form-checkbox>

                <b-form-checkbox
                  v-model="oldHighflowSmsAllowed"
                  :plain="true"
                  value="1"
                  unchecked-value="0"
                >
                  Highflow SMS Allowed
                </b-form-checkbox>
              </div>

              <div class="col-md-6 left">
                <b-form-checkbox
                  v-model="oldFrozenPipe"
                  :plain="true"
                  value="1"
                  unchecked-value="0"
                >
                  Frozen Pipe
                </b-form-checkbox>
              </div>

              <div class="clear" />

              <b-form-group>
                <p><strong>Leak Repaired Survey</strong></p>
                <b-form-input
                  v-model="oldLeakRepairedSurvey"
                  class="col-md-10"
                  type="text"
                />
              </b-form-group>

              <b-form-group>
                <p><strong>Leak Active No Diagnose Survey</strong></p>
                <b-form-input
                  v-model="oldLeakActiveNoDiagnoseSurvey"
                  class="col-md-10"
                  type="text"
                />
              </b-form-group>

              <b-form-group>
                <p><strong>Install Success Survey</strong></p>
                <b-form-input
                  v-model="oldInstallSuccessSurvey"
                  class="col-md-10"
                  type="text"
                />
              </b-form-group>

              <b-form-group>
                <p><strong>Leak Active Survey</strong></p>
                <b-form-input
                  v-model="oldLeakActiveSurvey"
                  class="col-md-10"
                  type="text"
                />
              </b-form-group>
            </div>
          </b-modal>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import tenantsListMixin from '../mixins/tenantsListMixin'

export default {
  name: 'TenantsList',
  mixins: [tenantsListMixin]
}
</script>

<style scoped>
  .lbv-device-list .clearBtn {
    margin-top: 10px;
  }

  .lbv-device-list .device-list-filters {
    margin: 0px 0px;
    border-bottom: 1px solid #C7CFCA;
    background-color: rgba(242, 242, 242, 1);
  }
  .tenant-list .lbv-page-title {
    width: 100%;
  }
  .addTenantBtn {
    float: right;
  }
  .left {
    float: left;
  }
  .clear{
    clear: both;
  }

  p {
    margin-bottom: 5px;
  }

  .form-control {
    margin-bottom: 10px;
  }

  .tenantLink {
    color: #22D3C5;
  }

  .form-check-inline + .form-check-inline {
    margin-left: 0;
  }

</style>
